// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"52b60bf8","453":"89c66535","811":"e011e649"}[chunkId] + ".chunk.js";
};